<template>
  <div class="confirmation">    
    <div class="appointment-info">
      <div class='left'>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 131 102">
          <g fill-rule="evenodd">
            <path
              d="M88 94.828H7.189C3.225 94.828 0 91.61 0 87.656V11.555C0 7.6 3.225 4.383 7.189 4.383h96.92c3.964 0 7.19 3.218 7.19 7.172v38.25h-4.793v-38.25a2.396 2.396 0 0 0-2.396-2.39H7.189a2.396 2.396 0 0 0-2.396 2.39v76.101a2.396 2.396 0 0 0 2.396 2.39H88v4.782Z"
            />
            <path
              d="M24.896 13.148h4.793V0h-4.793zM50.457 13.148h4.793V0h-4.793zM77.616 13.148h4.793V0h-4.793zM32.085 46.418h5.792V40.64h-5.792v5.778Zm-3.195 3.187h12.182V37.453H28.89v12.152ZM48.061 46.418h5.791V40.64h-5.791v5.778Zm-3.195 3.187h12.181V37.453H44.866v12.152ZM64.037 46.418h5.79V40.64h-5.79v5.778Zm-3.195 3.187h12.18V37.453h-12.18v12.152ZM80.012 46.418h5.791V40.64h-5.79v5.778Zm-3.195 3.187H89V37.453H76.817v12.152ZM16.11 62.355H21.9v-5.777H16.11v5.777Zm-3.195 3.188h12.181V53.39H12.915v12.153ZM32.085 62.355h5.792v-5.777h-5.792v5.777Zm-3.195 3.188h12.182V53.39H28.89v12.153ZM48.061 62.355h5.791v-5.777h-5.791v5.777Zm-3.195 3.188h12.181V53.39H44.866v12.153ZM64.037 62.355h5.79v-5.777h-5.79v5.777Zm-3.195 3.188h12.18V53.39h-12.18v12.153ZM16.11 78.293H21.9v-5.778H16.11v5.778Zm-3.195 3.187h12.181V69.328H12.915V81.48ZM32.085 78.293h5.792v-5.778h-5.792v5.778ZM28.89 81.48h12.182V69.328H28.89V81.48ZM48.061 78.293h5.791v-5.778h-5.791v5.778Zm-3.195 3.187h12.181V69.328H44.866V81.48ZM64.037 78.293h5.79v-5.778h-5.79v5.778Zm-3.195 3.187h12.18V69.328h-12.18V81.48ZM104.305 101.075c-14.647 0-26.561-11.887-26.561-26.499 0-14.611 11.914-26.5 26.56-26.5 6.79 0 13.253 2.556 18.197 7.193a2.39 2.39 0 0 1 .104 3.38 2.401 2.401 0 0 1-3.387.104 21.72 21.72 0 0 0-14.913-5.895c-12.004 0-21.769 9.743-21.769 21.718 0 11.976 9.765 21.718 21.769 21.718 12.004 0 21.768-9.742 21.768-21.718 0-3.497-.807-6.837-2.398-9.923a2.387 2.387 0 0 1 1.035-3.219 2.404 2.404 0 0 1 3.227 1.033 26.179 26.179 0 0 1 2.929 12.11c0 14.61-11.915 26.498-26.561 26.498M73.488 26.297h24.497v-4.782H73.488zM40.739 26.297h27.426v-4.782H40.739zM12.915 26.297h22.5v-4.782h-22.5z"
            />
            <path
              d="M115.631 80.36h-11.326a2.394 2.394 0 0 1-2.397-2.39V62.458a2.393 2.393 0 0 1 2.397-2.39 2.393 2.393 0 0 1 2.396 2.39v13.12h8.93a2.394 2.394 0 0 1 2.397 2.39c0 1.32-1.074 2.39-2.397 2.39"
            />
          </g>
        </svg>
      </div>
      <div class="appointment">
        <div class="message"><span>{{response.message}}</span><br/><br/>We look forward to highlighting our vison for San Diego FC and welcoming you for our inaugural 2025 season and the subsequent years to come!</div>
        <div class="date" v-html="response.date" />
        <h3>Primary Attendee Info:</h3>
        <div class="primary" v-html="response.primary" />
        <div class="guests" v-if="response.guests !== ''">
          <h3>Additional Attendees Info:</h3>
          <div class="guest-info" v-html="response.guests" />
        </div>    
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button";
export default {
  name: "Confirmation",
  components: {
    Button,
  },
  props: {
    response:Object
  },
  data() {
    return {
      /*
      response: {
        message: "Richard, you have successfully booked an appointment!",
        date: "June 24, 2022 &bull; 8:30 am",
        primary:
          "<p class='full-name'>Test F Tesxt L (test d)</p> <p class='email'>richard@channel1media.com</p> <p class='phone'>6546546565</p> <p class='company'>Company</p> <p class='address'>65 Address</p> <p class='notes'>ntoes</p>",
        guests:
          "<p class='guest'>Gf Gl (richard@channel1media.com)</p><p class='guest'>Gf Gl (richard@channel1media.com)</p>",
      },
      /* */
    };
  },
};
</script>

<style lang="scss" scoped>
.book {
  position: absolute;
  bottom: 30px;
  right: 50px;
  width: calc(100% - 100px);
  @media (min-width: 1000px) {
    width: auto;
    right: 30px;
  }
}
.confirmation {
  flex-direction: column;
  color: var(--white);
  background: rgba(11, 24, 43, 0.70);  
  font-size: 1rem;
  overflow:hidden;
  > div {
    font-size:1rem;
    
  }
}

.date {  
  font-family: 'Sharp Grotesk';
  font-size: 2rem;  
  padding: 20px 0;
  text-transform: uppercase;
}
h3 {
  font-family: 'Sharp Grotesk';
  font-weight: normal;
  margin-bottom: 0;    
}
.primary {
  :deep() {
    p {
      font-family:'Modern Era';
      font-weight: 400;
      margin: 8px 0;
      font-size: 1rem;
    }
  }
}
.guest-info {
  :deep() {
    .guest {
      font-size: 1rem;
      margin: 4px 0;
      &:first-child {
        margin-top: 1em;
      }
    }
  }
}
.appointment-info {
  display: flex;
  font-size: 1.25rem;
  flex-direction: column;    
  @media (min-width: 1000px) {
    flex-direction: row;
  }
  > div {
    padding: 15px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .left {
    max-width:280px;
    background:var(--dark-blue);
    padding:0 65px;
  }
  .appointment {
    padding: 75px 50px;
    align-items: flex-start;
    position: relative;
    text-align: left;    
    font-family:'Modern Era';
  }
  .message {
    span {
      font-family: 'Sharp Grotesk';
    }
  }
}

svg {
  fill: var(--white);
  width: 130px;
}
</style>